var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _rect2, _path12, _path13, _ellipse, _circle2, _rect3, _path14, _path15, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateLiveSuccessDark = function SvgCreateLiveSuccessDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 200 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#create_live_success_dark_svg__a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#282C2F"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M112.264 53.967c5.393-3.41 7.005-10.565 3.6-15.98s-10.537-7.04-15.93-3.63L68.915 53.971c-3.959 2.504-5.88 7.025-5.275 11.395l-6.398 4.046a4 4 0 0 0-.401.254l-2.673 1.69a4.78 4.78 0 0 0-1.482 6.58 4.75 4.75 0 0 0 5.959 1.817l4.807 7.645-.638.403a4.013 4.013 0 0 0-1.252 5.524l2.99 4.756 8.04-5.083 14.936-9.444-2.99-4.756a3.99 3.99 0 0 0-5.51-1.248l-7.953 5.029-.087.053-.64.404-4.78-7.603 3.148-1.992c3.671 2.433 8.57 2.644 12.53.14zm46.512 24.522c6.51 10.351 7.559 21.416 4.163 23.564l-6.071 3.838-.077.05-7.872 4.976v-.001l-5.259 3.325a4.01 4.01 0 0 1-1.621 4.775l-65.621 41.497-.098.06-7.943 5.022a3.987 3.987 0 0 1-5.51-1.248L37.87 124.589a4.01 4.01 0 0 1 1.252-5.524l57.581-36.413q.08-.05.16-.096l19.645-12.423a3.99 3.99 0 0 1 5.51 1.249l1.868 2.97 3.103-1.962.047-.029 6.179-3.906h-.001l6.15-3.888c3.396-2.148 12.902 3.57 19.412 13.922M90.873 86.32l5.867-3.71v.001l13.776-8.71a1.79 1.79 0 0 0-2.473-.56l-10.395 6.573a3.99 3.99 0 0 0-4.31-.028l-26.55 16.786-.051.033-7.988 5.051a4.01 4.01 0 0 0-1.251 5.524l.064.102z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "M166.669 96.428c3.399-2.149 2.356-13.215-4.152-23.564-6.507-10.35-16.014-16.063-19.413-13.914l-6.154 3.891 23.566 37.478z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M160.522 100.316c4.35-2.751 2.601-13.37-3.906-23.72s-15.309-16.508-19.659-13.757l-7.876 4.98 23.564 37.477z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E33",
    d: "M154.295 104.252c3.985-2.52 1.94-12.952-4.567-23.301-6.507-10.35-15.013-16.696-18.998-14.176l-7.553 4.776 23.565 37.478z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    fillRule: "evenodd",
    d: "M119.599 32.365c3.405 5.415 1.792 12.57-3.601 15.98L84.979 67.96c-5.393 3.41-12.525 1.785-15.93-3.63-3.404-5.414-1.792-12.568 3.6-15.979l31.02-19.615c5.393-3.41 12.525-1.785 15.93 3.63",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M60.771 63.91a4.073 4.073 0 0 1 5.626 1.282l10.61 16.873a4.1 4.1 0 0 1-1.273 5.643 4.073 4.073 0 0 1-5.625-1.282l-10.61-16.873a4.1 4.1 0 0 1 1.272-5.643",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M79.395 57.784a4.78 4.78 0 0 1-1.483 6.58l-14.935 9.444a4.75 4.75 0 0 1-6.56-1.495 4.78 4.78 0 0 1 1.483-6.58l14.935-9.443a4.75 4.75 0 0 1 6.56 1.494",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "M69.272 96.575a4.01 4.01 0 0 1 1.252-5.524l26.55-16.786a3.99 3.99 0 0 1 5.509 1.248l.064.102-33.31 21.062zM73.337 82.62a4.013 4.013 0 0 1 1.252-5.524l8.174-5.17a3.987 3.987 0 0 1 5.51 1.25l2.99 4.755-14.936 9.445z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#create_live_success_dark_svg__b)",
    d: "M49.644 113.89a4.013 4.013 0 0 1 1.252-5.524l69.348-43.854a3.986 3.986 0 0 1 5.509 1.249l3.043 4.839a31.1 31.1 0 0 1 4.251 10.9 31.1 31.1 0 0 0 4.252 10.901l9.725 15.467a4.014 4.014 0 0 1-1.252 5.525l-65.624 41.498a3.987 3.987 0 0 1-5.51-1.248z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.132,
    height: 54.96,
    fill: "#464B52",
    rx: 4,
    transform: "rotate(-32.308 219.253 -10.35)skewX(-.15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M61.23 101.658a4.01 4.01 0 0 1 1.252-5.524l26.55-16.786a3.99 3.99 0 0 1 5.51 1.248l.064.102-33.312 21.062z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M65.295 87.704a4.013 4.013 0 0 1 1.252-5.524l8.175-5.17a3.987 3.987 0 0 1 5.51 1.249l2.99 4.755-14.937 9.445z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    d: "M100.474 76.99a1.8 1.8 0 0 1 .561-2.48l10.741-6.79a1.79 1.79 0 0 1 2.473.56z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 51.664,
    height: 46.719,
    fill: "#32363B",
    rx: 1.333,
    transform: "rotate(-32.309 216.18 -47.582)skewX(-.15)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1F",
    d: "m60.612 108.793 41.756-26.406 23.328 37.104-41.756 26.406z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#32363B",
    stroke: "#191C1F",
    strokeWidth: 1.333,
    d: "M66.082 138.722c3.807-2.408 4.92-7.476 2.506-11.316-2.414-3.839-7.454-5.017-11.261-2.609s-4.92 7.476-2.506 11.316c2.414 3.839 7.454 5.017 11.261 2.609Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.399,
    cy: 3.435,
    fill: "#191C1F",
    rx: 3.399,
    ry: 3.435,
    transform: "rotate(-32.309 254.054 -33.06)skewX(-.15)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.165,
    cy: 1.165,
    r: 1.165,
    fill: "#D6342C",
    transform: "rotate(-32.309 219.987 -56.288)skewX(-.15)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.657,
    height: 1.164,
    fill: "#1BEE74",
    rx: 0.582,
    transform: "rotate(-32.306 300.04 -50.974)skewX(-.145)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6342C",
    d: "m119.242 74.031 8.364-5.288.93 1.478-8.364 5.289z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#191B1F",
    d: "m141.519 108.195 4.07-2.574-7.365-15.245a17.4 17.4 0 0 1-1.232-3.428l-.596-2.439a18.7 18.7 0 0 0-2.332-5.508l-5.52-8.778-8.369 5.292a18.5 18.5 0 0 1 2.466 6.255c.829 4.165 1.376 8.61 3.635 12.201l7.897 12.559a5.316 5.316 0 0 0 7.346 1.665"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 282.226 -37.153)skewX(-.147)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 223.846 -20.398)skewX(-.147)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 282.81 -35.142)skewX(-.147)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 224.431 -18.392)skewX(-.147)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 292.293 -40.04)skewX(-.147)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 292.876 -38.035)skewX(-.147)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 278.154 -51.22)skewX(-.147)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 219.774 -34.466)skewX(-.147)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 278.738 -49.21)skewX(-.147)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 220.358 -32.455)skewX(-.147)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#212326",
    rx: 1.165,
    transform: "rotate(-32.307 288.22 -54.108)skewX(-.147)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.658,
    height: 2.329,
    fill: "#32363B",
    rx: 1.165,
    transform: "rotate(-32.307 288.802 -52.097)skewX(-.147)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 15.135,
    height: 3.493,
    fill: "#191C1F",
    rx: 1.333,
    transform: "rotate(-32.305 235.097 -19.277)skewX(-.142)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 12.805,
    height: 1.164,
    fill: "#32363B",
    rx: 0.582,
    transform: "rotate(-32.304 236.535 -21.868)skewX(-.14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#282C31",
    d: "m49.28 122.399.984-.623.62.987-.985.622zM51.245 121.154l.985-.623.62.987-.985.622zM53.214 119.91l.985-.623.62.987-.985.622zM55.183 118.665l.985-.623.62.987-.985.622zM57.149 117.422l.985-.623.62.987-.985.622z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FC75E",
    d: "M148.691 166.715c15.109 0 27.357-12.249 27.357-27.358S163.8 112 148.691 112s-27.358 12.248-27.358 27.357 12.249 27.358 27.358 27.358"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.345 140.202a1.264 1.264 0 0 1 0-1.794l1.794-1.794a1.26 1.26 0 0 1 1.794 0l5.564 5.564 11.923-11.924a1.26 1.26 0 0 1 1.794 0l1.793 1.794a1.26 1.26 0 0 1 0 1.794l-14.599 14.628a1.26 1.26 0 0 1-1.794 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_live_success_dark_svg__b",
    x1: 85.57,
    x2: 114.943,
    y1: 86.439,
    y2: 132.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32363B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "create_live_success_dark_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#fff",
    rx: 100
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateLiveSuccessDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "create_live_success_dark.svg";